import { writable } from 'svelte/store';
const snackbarOptionsDefault = {
    isOpen: false,
    message: '',
    color: 'secondary',
    ttl: 8000,
    textColor: 'white',
    ctaAppearance: 'outlined',
    ctaColor: 'white',
    ctaLabel: undefined,
    ctaAction: undefined,
    ctaUrl: undefined,
    ctaUrlTargetBlank: true,
    iconName: undefined
};
const snackbarStore = (options) => {
    const store = writable(options);
    const open = (options) => {
        store.update(() => ({ ...snackbarOptionsDefault, ...options, isOpen: true }));
    };
    const success = (message, options) => {
        store.update(() => ({
            ...snackbarOptionsDefault,
            ...options,
            isOpen: true,
            color: 'success',
            message
        }));
    };
    const warning = (message, options) => {
        store.update(() => ({
            ...snackbarOptionsDefault,
            ...options,
            isOpen: true,
            color: 'warning',
            message
        }));
    };
    const danger = (message, options) => {
        store.update(() => ({
            ...snackbarOptionsDefault,
            ...options,
            isOpen: true,
            color: 'danger',
            message
        }));
    };
    const reset = () => {
        store.update(() => ({ ...snackbarOptionsDefault }));
    };
    return {
        ...store,
        open,
        success,
        danger,
        warning,
        reset
    };
};
export const snackbar = snackbarStore(snackbarOptionsDefault);
